module.exports = __webpack_public_path__ + "img/coverfx3.f20b7fc1.jpg";